import React from 'react';
import { PWAInstallModal } from './PWAInstallModal';

export const GlobalPWAInstallModal = () => {
  return <PWAInstallModal />;
};
